"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./Bindings"), exports);
__exportStar(require("./ComunicaDataFactory"), exports);
__exportStar(require("./IActionContext"), exports);
__exportStar(require("./IAggregatedStore"), exports);
__exportStar(require("./ICliArgsHandler"), exports);
__exportStar(require("./IDataDestination"), exports);
__exportStar(require("./IDataset"), exports);
__exportStar(require("./IJoinEntry"), exports);
__exportStar(require("./IMetadata"), exports);
__exportStar(require("./IPhysicalQueryPlanLogger"), exports);
__exportStar(require("./IProxyHandler"), exports);
__exportStar(require("./IQueryContext"), exports);
__exportStar(require("./IQueryEngine"), exports);
__exportStar(require("./IQueryOperationResult"), exports);
__exportStar(require("./IQuerySource"), exports);
__exportStar(require("./statistics/IStatisticBase"), exports);
__exportStar(require("./statistics/IDiscoverEventData"), exports);
__exportStar(require("./statistics/IPartialResult"), exports);
__exportStar(require("./ILink"), exports);
__exportStar(require("./Logger"), exports);
__exportStar(require("./ExpressionEvaluator"), exports);
//# sourceMappingURL=index.js.map